import { useEffect, useState } from 'react';
import {
  pinRequest,
  signInStaff,
  validStaffPin,
  type PinDirectoryEntry,
} from '../../lib/staff-pin';
export function StaffPinLogin() {
  const [directory, setDirectory] = useState<PinDirectoryEntry[]>([]),
    [selector, setSelector] = useState(''),
    [pin, setPin] = useState(''),
    [error, setError] = useState(''),
    [busy, setBusy] = useState(false),
    [loading, setLoading] = useState(true);
  useEffect(() => {
    let mounted = true;
    void pinRequest('/directory').then(
      (value) => {
        if (mounted) {
          setDirectory(value as PinDirectoryEntry[]);
          setLoading(false);
        }
      },
      () => {
        if (mounted) {
          setError('โหลดรายชื่อไม่ได้ กรุณาตรวจสอบการเชื่อมต่อหรือติดต่อผู้ดูแล');
          setLoading(false);
        }
      },
    );
    return () => {
      mounted = false;
    };
  }, []);
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        setBusy(true);
        setError('');
        void signInStaff(selector, pin)
          .then(
            () => {
              if (window.location.pathname === '/login') history.replaceState(null, '', '/app');
              dispatchEvent(new Event('sqi-session-changed'));
            },
            (e: unknown) => setError(e instanceof Error ? e.message : 'เข้าสู่ระบบไม่ได้'),
          )
          .finally(() => {
            setPin('');
            setBusy(false);
          });
      }}
    >
      <label>
        ชื่อของคุณ
        <select
          disabled={loading || busy}
          autoComplete="off"
          required
          value={selector}
          onChange={(e) => setSelector(e.target.value)}
        >
          <option value="">{loading ? 'กำลังโหลดรายชื่อ…' : 'เลือกชื่อ'}</option>
          {directory.map((entry) => (
            <option key={entry.selector} value={entry.selector}>
              {entry.label}
            </option>
          ))}
        </select>
      </label>
      <label>
        รหัส 6 หลัก
        <input
          type="password"
          inputMode="numeric"
          pattern="[0-9]{6}"
          minLength={6}
          maxLength={6}
          autoComplete="off"
          required
          value={pin}
          onChange={(e) => setPin(e.target.value)}
        />
      </label>
      <button
        className="action"
        disabled={busy || !selector || !validStaffPin(pin) || !navigator.onLine}
      >
        {busy ? 'กำลังเข้าสู่ระบบ…' : 'เข้าสู่ระบบทีมงาน'}
      </button>
      <p className="muted">ใช้รหัส 6 หลักที่ผู้ดูแลกำหนด · ต้องเชื่อมต่ออินเทอร์เน็ต</p>
      {error ? (
        <p role="alert" className="note-danger">
          {error}
        </p>
      ) : null}
    </form>
  );
}
